import {
  type PageEntity,
  apiClient,
  type ShipmentCategoryEntity
} from '@/libs/api'
import { type ShipmentCategoriesRequestQuery } from '@/libs/api/types'

export type FetchShipmentCategoriesQuery = {
  tenantKey: string
  query?: ShipmentCategoriesRequestQuery
  dcId?: number
}

export type FetchShipmentCategoriesResponse = {
  data: ShipmentCategoryEntity[]
  pagination: PageEntity | null
}

/**
 * 配送種別一覧を取得（ページングなし）
 */
export const fetchShipmentCategories = async (
  { tenantKey, query, dcId }: FetchShipmentCategoriesQuery,
  signal?: AbortSignal
): Promise<FetchShipmentCategoriesResponse> => {
  const finalQuery = {
    ...query,
    ...(dcId ? { dcId } : {})
  }

  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .shipment_categories.$get({
      query: finalQuery,
      config: {
        signal
      }
    })

  return {
    data,
    pagination
  }
}
